<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormNotaPago" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="FechaRegistro">Fecha Registro</label>
									<input type="text" v-model="objSalida.FechaRegistro" class="form-control" id="FechaRegistro" placeholder="Ingresar FechaRegistro" readonly />
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="FechaSalida">Fecha Salida</label>
									<input type="text" v-model="objSalida.FechaSalida" class="form-control" id="FechaSalida" placeholder="Ingresar FechaSalida" readonly />
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="Folio">Folio Salida</label>
									<input type="text" v-model="objSalida.Folio" class="form-control" id="Folio" placeholder="Ingresar Folio" readonly />
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="Elaboro">Elabora</label>
									<input type="text" v-model="objSalida.NombreElaboroEnAlmacen" class="form-control" id="Elaboro" placeholder="Ingresar Elaboro" readonly />
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" v-if="objSalida.ResponsableAlmacen>0">
									<label class="form-label" for="Elaboro">Autoriza Salida</label>
									<input type="text" v-model="objSalida.NombreResponsableAlmacen" class="form-control" id="ResponsableAlmacen" placeholder="Responsable Almacen" readonly />
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="ResponsableRecibe">Recibe</label>
									<div class="input-group">
										<input type="text" v-model="objSalida.NombreResponsableRecibe" class="form-control" id="ResponsableRecibe" placeholder="Ingresar Recibe" readonly />
										<button type="button" @click="AbrirModalPersonal()" class="btn btn-outline-primary boder-extend" id="button-addon1" :disabled="objSalida.Estatus !='Elaborado'">
											<i class="fa fa-search"></i>
										</button>
									</div>
									<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/>
								</div>
							</div>

							<div class="form-group row" v-if="objSalida.RecibioEnAlmacen>0">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="Elaboro">Recibe en Almacen</label>
									<input type="text" v-model="objSalida.NombreRecibeEnAlmacen" class="form-control" id="Elaboro" placeholder="Ingresar Elaboro" readonly />
								</div>
							</div>
							
							
							<hr class="horizontal dark">

							<div class="row">
								<div class="col-6 col-sm-6 col-md-6 col-lg-6">
									<p class="text-uppercase text-sm">Agregar Elementos</p>
								</div>
								<div class="col-6 col-sm-6 col-md-6 col-lg-6 text-end">
									<button type="button" @click="AbrirModalMateriales()" class="btn btn-primary" id="button-addon2">
										<i class="fa fa-plus-circle"></i> Agregar
									</button>
								</div>
							</div>


							<div class="row justify-content-center">
								<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
								<CLoader :pConfigLoad="ConfigLoadTable">
								<template slot="BodyFormLoad">
									<div class="table-responsive pb-0">
										<table class="table table-striped mb-0">
											<thead>
												<tr>
													<th width="5%">#</th>
													<th width="30%">Material</th>
													<th width="10%">Stock</th>
													<th width="15%">Cantidad Salida</th>
													<th width="10%">Tipo de Material</th>
													<th width="5%">*</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaConceptosSalida" :key="index">
													<td>
														{{(index+1)}}
													</td>
													<td>
														<textarea v-model="item.Nombre" name="Material" id="Material" class="form-control form-control-sm" rows="2" readonly></textarea>
													</td>
													<td>
														<input type="text" v-model="item.Stock" class="form-control form-control-sm" readonly>
													</td>
													<td>
														<input type="text" v-model="item.CantidadSalida" @input="$onlyNums($event,item,'CantidadSalida');CalculaStock(item)" class="form-control form-control-sm" :readonly="(item.IdSolicitudAlmacenDetalle >0)?true:false">
													</td>
													
													<td style="text-wrap:wrap;">
														
														{{item.TipoMaterial}}
														
													</td>
													<td>
														<button type="button" @click="EliminarItemConcepto(index,item)" class="btn btn-danger btnpequenio">
															<i class="fa fa-trash"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
								</template>
								</CLoader>
								</div>
							</div>

								
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objSalida.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>
							</div>
							
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
						</form>

						<CModal :pConfigModal="ConfigModal1" :poBtnSave="oBtnSave1">
							<template slot="Form">
								<ListMateriales :poBtnSave="oBtnSave1"></ListMateriales>
							</template>
						</CModal>

						<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
							<template slot="Form">
								<ListUsuarios :poBtnSave="oBtnSave2"></ListUsuarios>
							</template>
						</CModal>
					</div>
				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';

import ListMateriales from '@/views/modulos/almacen/solicitudSalida/ListMateriales.vue';
import ListUsuarios from '@/views/modulos/almacen/solicitudSalida/ListUsuarios.vue';
/* import ListFacturas from '@/views/modulos/finanzas/notaPago/ListFacturas.vue'; */

const EmitEjecuta = 'seccionNotaPago';
const EmitEjecuta1 = 'seccionMaterialesSalida';
const EmitEjecuta2 = 'seccionPersonalSalida';


export default {
    name: 'FormNotaPago',
    props: ['Id'],
    components:{
		ListMateriales,
		ListUsuarios,
		/* ListFacturas, */
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario de Salidas',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'solicitudSalida',
                EmitSeccion: EmitEjecuta,
				ShowBtnSave: true,
            },
			ConfigLoadTable:{
                ShowLoader: false,
                ClassLoad: false,
            },
			ConfigModal1:{
                ModalTitle: "Listado de Materiales",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta1,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave1: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta1,
            },
			ConfigModal2:{
                ModalTitle: "Personal",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            objSalida: {
				IdSolicitudAlmacen: 0,
				IdCotizacion: 0,
				IdCliente: 0,
				IdContacto: 0,
				IdAgente: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				Folio: '',
				ElaboroEnAlmacen: 0,
				RecibioEnAlmacen: 0,
				ResponsableRecibe: 0,
				ResponsableAlmacen: 0,
				FechaEvento: '',
				FechaRegistro: '',
				FechaSalida: '',
				Observaciones: '',
				Estatus: 'Elaborado',
				TipoSalida: 'Materiales',
				SalidaAsociada: 0,

				NombreElaboroEnAlmacen: '',
				NombreRecibioEnAlmacen: '',
				NombreResponsableRecibe: '',
				NombreResponsableAlmacen: '',
				
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
			ListaConceptosSalida: [],
			Setpicker: Calendar.calendarSettings,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let band1 = 0;
            let msg1 = '';

			if(this.ListaConceptosSalida.length == 0)
			{
				this.$toast.warning('Debe agregar al menos un elemento.')
				return false;
			}

			$.each(this.ListaConceptosSalida, function(key, value){
                if(value.CantidadSalida == 0){
                    msg1 = "El campo cantidad de salida de la partida: "+(key+1)+" no puede estar vacio ni ser cero";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); return false; }
			

			let formData = new FormData();
			formData.set('IdSolicitudAlmacen', this.objSalida.IdSolicitudAlmacen);
			formData.set('IdCotizacion', this.objSalida.IdCotizacion);
			formData.set('IdCliente', this.objSalida.IdCliente);
			formData.set('IdContacto', this.objSalida.IdContacto);
			formData.set('IdAgente', this.objSalida.IdAgente);
			formData.set('IdEmpresa', this.objSalida.IdEmpresa);
			formData.set('IdSucursal', this.objSalida.IdSucursal);

			formData.set('Folio', this.objSalida.Folio);
			formData.set('ElaboroEnAlmacen', this.objSalida.ElaboroEnAlmacen);
			formData.set('RecibioEnAlmacen', this.objSalida.RecibioEnAlmacen);
			formData.set('ResponsableRecibe', this.objSalida.ResponsableRecibe);
			formData.set('ResponsableAlmacen', this.objSalida.ResponsableAlmacen);
			formData.set('FechaEvento', this.objSalida.FechaEvento);
			formData.set('FechaRegistro', this.objSalida.FechaRegistro);
			formData.set('FechaSalida', this.objSalida.FechaSalida);
			formData.set('Observaciones', this.objSalida.Observaciones);
			formData.set('Estatus', this.objSalida.Estatus);
			formData.set('TipoSalida', this.objSalida.TipoSalida);
			formData.set('SalidaAsociada', this.objSalida.SalidaAsociada);

			formData.set('Detalle', JSON.stringify(this.ListaConceptosSalida));
			
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('solicitudesAlmacen', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "solicitudesAlmacen/"+this.objSalida.IdNotaPago
            ).then((res) => {
                this.objSalida = res.data.data;
				let response = res.data.detalle;

				this.ListaConceptosSalida = response;


				// en caso de que necesite fecha
				/*let formatedDate1 = this.objSalida.Fecha.replace(/-/g,'\/');
                this.objSalida.Fecha = new Date(formatedDate1);*/

				if(this.objSalida.Estatus != 'Elaborado'){
					this.oBtnSave.ShowBtnSave = false;
				}
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objSalida = {
				IdSolicitudAlmacen: 0,
				IdCotizacion: 0,
				IdCliente: 0,
				IdContacto: 0,
				IdAgente: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				Folio: '',
				ElaboroEnAlmacen: 0,
				RecibioEnAlmacen: 0,
				ResponsableRecibe: 0,
				ResponsableAlmacen: 0,
				FechaEvento: '',
				FechaRegistro: moment(new Date()).format('YYYY-MM-DD'),
				FechaSalida: '',
				Observaciones: '',
				Estatus: 'Elaborado',
				TipoSalida: 'Materiales',
				SalidaAsociada: 0,

				NombreElaboroEnAlmacen: '',
				NombreRecibioEnAlmacen: '',
				NombreResponsableRecibe: '',
				NombreResponsableAlmacen: '',
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		AbrirModalMateriales()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta1,this.ListaConceptosSalida);
		},
		AbrirModalPersonal()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta2,this.objSalida.ResponsableRecibe);
		},
		SetElabora()
		{
			let usuario = JSON.parse(sessionStorage.getItem('user'));
			//this.objSalida.IdAgente = usuario.IdAgente; 
			this.objSalida.ElaboroEnAlmacen = usuario.IdUsuario;
			this.objSalida.NombreElaboroEnAlmacen = usuario.NombreCompleto;
		},
		SetDataMaterial(obj)
		{
			this.ListaConceptosSalida.push(obj);
		},
		SetDataPersonal(obj){
			this.objSalida.ResponsableRecibe = obj.ResponsableRecibe;
			this.objSalida.NombreResponsableRecibe = obj.NombreResponsableRecibe;
		},
		CambiarPalabra(word)
		{
			let newWord = '';
			if(word!='' && word!=undefined){
				newWord = word.replace('~',' - ');
			}

			return newWord;
		},
		EliminarItemConcepto(index,item)
		{
			// SI EL REGISTRO ESTA GUARDADO MANDAMOS A ELIMINAR Y REGRESAR LAS CANTIDADES AL STOCK
			if(item.IdSolicitudAlmacenDetalle > 0)
			{
				this.$swal({
					title: '¿Desea Eliminar el registro?',
					text: 'Esta acción no se podra revertir y al eliminar, la cantidad solicitada retornara al stock original',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Aceptar',
					cancelButtonText: 'Cancelar',
					showCloseButton: true,
				}).then((result) => {
					if(result.value) {
						this.$http.get("solicitudAlmacenRetornar",{
							params:{
								IdSolicitudAlmacenDetalle: item.IdSolicitudAlmacenDetalle,
							}
						}).then((res) => {
							this.$toast.success('Elemento Eliminado');
							this.ListaConceptosSalida.splice(index, 1);
						}).finally(()=>{
							this.ConfigList.ShowLoader = false;
						}).catch(err => {
							this.$toast.error(err.response.data.message);
						});
					}
					else{
						this.ConfigList.ShowLoader = false;
					}
				});
			}
			else
			{
				// SI ES NUEVO SIMPLEMENTE LO ELIMINAMOS DE LOS NODOS
				this.ListaConceptosSalida.splice(index, 1);
			}
		},
		CalculaStock(item)
		{
			let Cantidad = item.CantidadSalida;
			let Stock = item.Stock;

			if(Cantidad>Stock){
				item.CantidadSalida = Stock;
			}
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('AgregarMaterialSalida');
        this.bus.$off('AgregarPersonal');

        //this.bus.$off('AgregarNotalRel');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.objSalida.IdNotaPago = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
			this.SetElabora();

		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('AgregarMaterialSalida',(obj)=>
        {
            this.SetDataMaterial(obj);
        });

        this.bus.$on('AgregarPersonal',(obj)=>
        {
            this.SetDataPersonal(obj);
        });
    }
}
</script>
